import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Federations } from "../../../organisation/models/federation";
import { SubscriptionService } from "../../../organisation/services/subscription.service";
import { SubscriptionRenewModalComponent } from "../../../subscription/pages/subscription-renew-modal/subscription-renew-modal.component";
import { CardWrapperComponent } from "../../form/components/card-wrapper/card-wrapper.component";
import { GlobalVariables } from "../../services/global.service";
import { BasePage } from "../layout/pages/base-page";

export type AssistSection =
  | "default"
  | "boekhouding"
  | "vrijwilligers"
  | "vacatures"
  | "leden"
  | "nieuwsbrief"
  | "gesprekken"
  | "activiteiten"
  | "formulieren"
  | "taken";

@Component({
  selector: "app-no-access",
  templateUrl: "./no-access.component.html",
  styleUrls: ["./no-access.component.scss"],
  standalone: true,
  imports: [CommonModule, CardWrapperComponent],
})
export class NoAccessComponent implements OnInit {
  @Input() url?: string;
  @Input() rubriek: AssistSection = "default";
  global = GlobalVariables;
  federations = Federations;
  startingTrail: boolean = false;
  subscriptionTypes: number[] | null = null;

  constructor(
    private modal: NgbModal,
    private router: Router,
    private subscriptionService: SubscriptionService,
    protected route?: ActivatedRoute
  ) {
    this.route?.data.subscribe((data) => {
      if (data["subscriptionTypes"]) this.subscriptionTypes = data["subscriptionTypes"];
    });
  }

  ngOnInit(): void {}

  hasRequredSubscription() {
    return (
      this.subscriptionTypes == null ||
      (this.global.subscription.SubscriptionTypeId &&
        this.subscriptionTypes.indexOf(this.global.subscription.SubscriptionTypeId) > -1)
    );
  }

  showSubscription(paymentKey: string = "") {
    var modal = this.modal.open(SubscriptionRenewModalComponent, {
      size: "lg",
    });
    modal.componentInstance.paymentKey = paymentKey;
  }

  startTrail() {
    var p = new BasePage(undefined, this.modal);
    p
      .confirm(
        "Proefperiode starten?",
        "Je staat op het punt om een eenmalige proefperiode van 30 dagen op Assist Plus te starten.\nBen je zeker dat je dit wil doen?"
      )
      ?.then((x) => {
        if (x) {
          this.startingTrail = true;
          this.subscriptionService.startTrail().subscribe((success) => {
            this.startingTrail = false;
            if (success) {
              location.reload();
            } else {
              p.alert(
                "Proefperiode niet mogelijk",
                "Je hebt als eens een proefperiode gehad op Assist Plus. Je kan meer 1 keer een 30 dagen proefperiode starten."
              );
            }
          });
        }
      });
  }

  get title() {
    switch (this.rubriek) {
      case "boekhouding":
        return "Deze pagina is beschikbaar in Assist START of Assist PLUS";
      case "leden":
      case "vrijwilligers":
        return "Deze pagina is beschikbaar in Assist PLUS";
      default:
        return "Deze pagina is niet beschikbaar in deze versie van Assist";
    }
  }
}
